import { render } from "./FilterSidebarInClosedSection.vue?vue&type=template&id=6cb1ddc4&scoped=true"
import script from "./FilterSidebarInClosedSection.vue?vue&type=script&lang=js"
export * from "./FilterSidebarInClosedSection.vue?vue&type=script&lang=js"

import "./FilterSidebarInClosedSection.vue?vue&type=style&index=0&id=6cb1ddc4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb1ddc4"]])

export default __exports__